import React, {
    useEffect,
    useMemo,
    useRef
} from 'react';

function offsetForResolution(element, boundingClientRect = element.getBoundingClientRect()) {
    if (!element) {
        return;
    }

    const windowWidth = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);

    if (windowWidth < 1199) {
        element.style.height = 'auto';
        element.classList.remove('tlw-overflow-y-auto');
        return;
    }

    const distanceFromTop = boundingClientRect.top + window.scrollY;
    const pxFromTop = Math.round(distanceFromTop);
    element.style.height = `calc(100vh - ${pxFromTop}px`;
    element.classList.add('tlw-overflow-y-auto');
}

function resizeCallback(entries) {
    const [entry] = entries;
    offsetForResolution(entry.target);
}

export default function WizardScrollingPanel({className, children}) {
    const ref = useRef(null);

    const observer = useMemo(() => {
        return new ResizeObserver(_.debounce(resizeCallback, 1000 / 60));
    }, []);

    useEffect(() => {
        if (ref.current) {
            observer.observe(ref.current);
        }

        return () => observer.disconnect();
    }, [observer, ref]);

    return (
        <div
            ref={ref}
            className={className}
        >
            {children}
        </div>
    );
}
